export const BASE_HREF = `${window.location.origin}/`;
